module.exports = __webpack_public_path__ + "static/media/PC54_good.880b6c01.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/options/PC54_good.jpg
// module id = 210
// module chunks = 0